import { withInstall } from '@ll-plus/utils'

import Drawer from './src/drawer.vue'

export const LlDrawer = withInstall(Drawer)

export default LlDrawer

export * from './src/drawer'
export * from './src/components/second-confirmation'

declare module 'vue' {
  export interface GlobalComponents {
    LlDrawer: typeof Drawer
  }
}
